import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=3d4b316c&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=3d4b316c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b316c",
  null
  
)

export default component.exports